import { ProposalStatus } from "@/models/proposalStatus";
import { Pagination } from "@/models/pagination";
import { IProposalStatus, ProposalStatusState } from "@/types/proposalStatus";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<ProposalStatusState, IProposalStatus> = {
  single: (state, single) => {
    state.single = new ProposalStatus(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new ProposalStatus(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new ProposalStatus();
    state.pagination = new Pagination();
  },
};

export default mutations;
